module.exports = __webpack_public_path__ + "img/美缔.489499f.png";